module.exports = __webpack_public_path__ + "static/meet-team-banner-3e76b6a217eafe6dc35674526a4f1644.jpg";